import { Typography, Tooltip } from '@mui/material';
import { WarningIcon } from 'components/CustomIcons';
import moment from 'moment';
import React, { useEffect } from 'react';
import PurchaseOrders from 'types/entities/PurchaseOrders';

const EndDateCell = React.memo((row: PurchaseOrders) => {
  const [dateFlag, setDateFlag] = React.useState(false);

  useEffect(() => {
    const today = new Date();
    const endDate = moment(row?.poend, 'YYYY-MM-DD').toDate();
    setDateFlag(endDate < today);
  }, [row?.poend]);

  return (
    <span>
      <Tooltip arrow title={row.poend ?? ''}>
        <Typography noWrap variant="body2">
          {row?.poend}
        </Typography>
      </Tooltip>

      {dateFlag && (
        <Tooltip arrow title="The end date is already expired">
          <Typography noWrap variant="body2" sx={{ ml: 1 }}>
            <WarningIcon color="error" />
          </Typography>
        </Tooltip>
      )}
    </span>
  );
});

export default EndDateCell;
